import {
	FixtureTypes,
	VesselOwnershipTypes,
} from '@shared/utils/constants';
import type Vessel from '@api/models/vessel';

type FixtureType = (typeof FixtureTypes)[keyof typeof FixtureTypes];

const getVesselOptions = (
	vessels: any[],
	type: 'myVessels' | 'marketVessels' | 'vesselIndex',
	fixtureType?: FixtureType,
): { label: string; value: number; ownershipType: string; imo:string; isGeneric: boolean; dwt: number }[] => {
	let filterFunction: (v: Vessel & { isGeneric: boolean }) => boolean;

	if (type === 'myVessels') {
		filterFunction = (v: Vessel & { isGeneric: boolean }) => (
			fixtureType !== FixtureTypes.TC_IN ||
            v.ownershipType === VesselOwnershipTypes.TC_IN
		) && v.ownershipType !== VesselOwnershipTypes.MARKET && !v.isGeneric;
	} else if (type === 'marketVessels') {
		filterFunction = (v: Vessel) => v.ownershipType === VesselOwnershipTypes.MARKET;
	} else if (type === 'vesselIndex') {
		filterFunction = (v: Vessel & { isGeneric: boolean }) => (
			v.isGeneric
		);
	} else {
		return [];
	}

	return (vessels || [])
		.filter(filterFunction)
		.sort((a, b) => a.name.toString().localeCompare(b.name))
		.map((v) => ({
			label: v.name,
			value: v.id,
			ownershipType: v.ownershipType,
			imo: v.imo,
			isGeneric: v.isGeneric,
			dwt: v.dwt,
		}));
};

export default getVesselOptions;
